import ViewResponse from "./ViewResponse";
export default ViewResponse